import React from 'react';
import useAuthStore from '../../store/authStore';
import { canAccess } from '../../utils/roles';
import AccessDenied from './AccessDenied';

// Usage: <RoleRoute module="lab"><LabComponent /></RoleRoute>
export default function RoleRoute({ module, children }) {
    const { user } = useAuthStore();
    if (!user) return null;
    if (!canAccess(user.role, module)) return <AccessDenied />;
    return children;
}
